import { render, staticRenderFns } from "./TagSearch.vue?vue&type=template&id=1307fbd6"
import script from "./TagSearch.vue?vue&type=script&lang=js"
export * from "./TagSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports